var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Support50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sWdP5XvpbW_0S2xbwZMBIa",
    x1: 32.372,
    x2: -5.278,
    y1: 3.091,
    y2: 68.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255b70"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sWdP5XvpbW_0S2xbwZMBIa)",
    d: "M28.52,26.14L12.17,42.49c-1.96,1.96-5.12,1.96-7.08,0l-3.12-3.12l19.89-19.89L28.52,26.14z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "sWdP5XvpbW_0S2xbwZMBIb",
    x1: 33,
    x2: 33,
    y1: -9.579,
    y2: 45.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faf3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255b70"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sWdP5XvpbW_0S2xbwZMBIb)",
    d: "M45,15c0,6.63-5.37,12-12,12s-12-5.37-12-12S26.37,3,33,3c1.48,0,2.89,0.27,4.2,0.76L29,12 l7,7l8.24-8.2C44.73,12.11,45,13.52,45,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Support50);
export default __webpack_public_path__ + "static/media/icons8-support-50.8613ebbbccd96f35293c7c711b539be4.svg";
export { ForwardRef as ReactComponent };